import Input from '../../../components/ui/Input';
import { MONO_CLASS } from '../../../components/ui/Mono';
import Select from '../../../components/ui/Select';
import { FCI_REQUIRED_ORIGINS, TAX_ORIGIN_OPTIONS } from '../../../constants/productCatalog';
import { FieldCell, FieldInputProps, FormSection } from '../editorParts';

/**
 * Tributação: referência do cadastro (a NF série 1 continua saindo do cadastro
 * do Bling — não há write-back). FCI só aparece com origem 3, 5 ou 8.
 */
const TaxSection = ({ ctx }) => {
    const { form } = ctx;
    const origin = String(form.tax_origin ?? '').trim();
    const showFci =
        (origin !== '' && FCI_REQUIRED_ORIGINS.includes(Number(origin))) || String(form.fci_number ?? '').trim() !== '';

    return (
        <FormSection
            id="tributacao"
            title="Tributação"
            description="Referência do cadastro. A NF série 1 continua saindo do cadastro do Bling."
        >
            <FieldCell span={6}>
                <Select label="Origem (ICMS)" {...FieldInputProps(ctx, 'tax_origin')}>
                    <option value="">Não informada</option>
                    {TAX_ORIGIN_OPTIONS.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </Select>
            </FieldCell>
            {showFci ? (
                <FieldCell span={6}>
                    <Input
                        label="Número FCI"
                        placeholder="XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX"
                        maxLength={36}
                        autoComplete="off"
                        spellCheck={false}
                        className={`${MONO_CLASS} uppercase`}
                        {...FieldInputProps(ctx, 'fci_number', {
                            hint: 'Ficha de Conteúdo de Importação (36 caracteres)',
                        })}
                    />
                </FieldCell>
            ) : null}
            <FieldCell span={3}>
                <Input
                    label="NCM"
                    placeholder="0000.00.00"
                    inputMode="numeric"
                    maxLength={10}
                    autoComplete="off"
                    className={MONO_CLASS}
                    {...FieldInputProps(ctx, 'ncm')}
                />
            </FieldCell>
            <FieldCell span={3}>
                <Input
                    label="CEST"
                    placeholder="00.000.00"
                    inputMode="numeric"
                    maxLength={9}
                    autoComplete="off"
                    className={MONO_CLASS}
                    {...FieldInputProps(ctx, 'cest')}
                />
            </FieldCell>
        </FormSection>
    );
};

export default TaxSection;
